import { ElementType, FC, memo, PropsWithChildren } from "react";
import Box, { type BoxProps } from "@mui/material/Box";
import CircularProgress, { type CircularProgressProps } from "@mui/material/CircularProgress";
import type { WithSlots } from "types";

type Props = WithSlots<
    BoxProps & {
        readonly isLoading: boolean;
        readonly component?: ElementType;
    },
    {
        readonly progress: CircularProgressProps;
    }
>;

const Loader: FC<PropsWithChildren<Props>> = ({
    isLoading,
    children,
    sx,
    slotProps,
    component: LoadingComponent = CircularProgress
}) => (
    <>
        {isLoading
            ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        ...sx
                    }}
                >
                    <LoadingComponent
                        {...slotProps?.progress}
                    />
                </Box>
            )
            : children}
    </>
);

export default memo(Loader);
